define.alias("shared/components/shared/modal/banner", "settings/components/shared/modal/banner");